import moment from "moment";
import React, { createContext, useEffect, useState } from "react";

const JobCardDataContext = createContext();

export const JobCardDataProvider = ({ children }) => {
  const [paperMachineData, setPaperMacineData] = useState();
  const [paperMachineOrdersData, setPaperMachineOrdersData] = useState([]);
  const [orderSummaryTable, setOrderSummaryTable] = useState({});
  const [stopCancelled, setStopCancelled] = useState(false);
  const [acceptedJCGrpCode, setAcceptedJCGrpCode] = useState([]);
  const [storedAppliedFilters, setStoredAppliedFilters] = useState([{
      type: "updated_date",
      start_date: moment().subtract(15,"days").format("YYYY-MM-DD"),
      end_date: moment().add(1,"day").format("YYYY-MM-DD")
    }]);
  const [storedFilterTags, setStoredFilterTags] = useState([]);
  const [storeModifiedFilterLabel, setStoreModifiedFilterLabel] = useState("Last 15 days");
  const [isAllFilterApplied, setIsAllFilterApplied] = useState(false);
  const handleResetAll = (log) => {
    // setPaperMacineData(null);
    setPaperMachineOrdersData([]);
    setOrderSummaryTable({});
    setStopCancelled(false);
    setAcceptedJCGrpCode([]);
  };

  const handleBackPathForJC = () => {
    let backPath = Object.keys(orderSummaryTable).length > 0 ||
      paperMachineOrdersData.length > 0;
      console.log("backPath", backPath);
      
    return (
      backPath
    );
  };
const removeGrpsFromOrderSummary = (newData) => {
  setOrderSummaryTable((prevState) => ({
    ...prevState,
    state: {
      ...prevState.state,
      data: newData,
    },
  }));
}
const handleFilterReset=() => {
    setStoredAppliedFilters([]);
    setStoredFilterTags([]);
    setStoreModifiedFilterLabel("Last 15 days");
    setIsAllFilterApplied(false);
}

  useEffect(() => {
    console.log(
      "paperMachineData",
      paperMachineData,
      "paperMachineOrdersData",
      paperMachineOrdersData,
      "orderSummaryTable",
      orderSummaryTable,
      "stopCancelled",
      stopCancelled
    );
  }, [
    paperMachineData,
    paperMachineOrdersData,
    orderSummaryTable,
    stopCancelled,
  ]);
  
  return (
    <JobCardDataContext.Provider
      value={{
        paperMachineData,
        setPaperMacineData,
        paperMachineOrdersData,
        setPaperMachineOrdersData,
        orderSummaryTable,
        setOrderSummaryTable,
        handleResetAll,
        stopCancelled,
        setStopCancelled,
        handleBackPathForJC,
        acceptedJCGrpCode,
        setAcceptedJCGrpCode,
        removeGrpsFromOrderSummary,
        storedAppliedFilters,
        setStoredAppliedFilters,
        storedFilterTags, setStoredFilterTags,
        storeModifiedFilterLabel, setStoreModifiedFilterLabel,
        isAllFilterApplied, setIsAllFilterApplied,
        handleFilterReset
      }}
    >
      {children}
    </JobCardDataContext.Provider>
  );
};

export default JobCardDataContext;
